
































import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import InputFileV2 from '@/components/inputsV2/InputFileV2.vue'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import { TemplateModule } from '@/store/modules/template.module'
import { getModule } from 'vuex-module-decorators'
import { required } from 'vuelidate/lib/validators'
import { ETemplateType } from '@zunta/configurations/dist/types/template'
import { ESortOrder, ETemplateLevel, ITemplate } from '@zunta/configurations'

@Component({
  components: { InputValidator, InputFileV2, ModalV2 }
})
export default class UploadLetterModal extends Vue {
  templateModuleInstance: TemplateModule = getModule(TemplateModule, this.$store)

  pdf: any = null
  storagePdfName = ''
  originalPdfName = ''

  isLoading = false
  isLoadingPdf = false

  validations (): any {
    return {
      pdf: {
        required
      }
    }
  }

  get lettersList () {
    return this.$store.state.template.templates
      .filter((template: ITemplate) => template.type === ETemplateType.LETTER_PDF || template.type === ETemplateType.LETTER)
  }

  async uploadPdf (item: any): Promise<any> {
    this.originalPdfName = item.name
    try {
      this.isLoadingPdf = true
      const res = await this.templateModuleInstance.uploadPDFLetter(item)
      if (typeof res === 'string') {
        const regex = /pdf-letters\/(.*)/gm
        this.storagePdfName = res.replace(regex, '$1')
        this.pdf = this.originalPdfName
      }
    } finally {
      this.isLoadingPdf = false
    }
  }

  async submit () {
    this.$v.$touch()

    if (this.$v.$anyError || this.isLoadingPdf) {
      return
    }

    try {
      this.isLoading = true
      const fileName = `ChainLetterPdf-${this.originalPdfName}`
      await this.templateModuleInstance.addTemplate({
        type: ETemplateType.LETTER_PDF,
        level: ETemplateLevel.CHAIN,
        // @ts-ignore
        title: this.pdfName,
        chain: this.$store.state.chain.chain ? this.$store.state.chain.chain.id : undefined,
        body: '',
        fileName: this.storagePdfName,
        templateName: fileName
      })
      await this.templateModuleInstance.fetchTemplates({
        sortBy: 'updatedAt',
        sortOrder: ESortOrder.DESC
      })
      this.$emit('submit', this.lettersList[0].id)
    } finally {
      this.isLoading = false
      this.$emit('notify', {
        color: 'var(--status-error-color)',
        header: 'Sent Invitation',
        message: 'Something went wrong',
        icon: 'warning'
      })
    }
  }
}
